<template>
  <handbook-list title="虫害手册" kindLabel="虫害" :api="api" />
</template>
<script>
import { pestApi } from '@/api/plantProtect'
import HandbookList from '../handbook/HandbookList.vue'
export default {
  name: 'PestHandbook',
  components: { HandbookList },
  data() {
    return { api: pestApi }
  },
}
</script>
